import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public search: any = {
        text: '',
        role: '',
        status: ''
    };

    public roles: string[] = ['USER', 'ADMIN'];
    public statuses: string[] = ['ACTIVE', 'INACTIVE'];
    public showCreateModal: boolean = false;
    public accountData: any = this.emptyAccount();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/access')) return;
        if (!this.service.auth.allow.role('ADMIN', '/dashboard')) return;
        await this.load();
    }

    public emptyAccount() {
        return {
            id: '',
            name: '',
            email: '',
            password: '',
            role: 'USER',
            status: 'ACTIVE'
        };
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('list', this.search);
        this.members = code === 200 ? (data || []) : [];

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? '' : role;
        await this.load();
    }

    public async filterByStatus(status: string) {
        this.search.status = this.search.status === status ? '' : status;
        await this.load();
    }

    public async openCreate() {
        this.accountData = this.emptyAccount();
        this.showCreateModal = true;
        await this.service.render();
    }

    public async createAccount() {
        const account = JSON.parse(JSON.stringify(this.accountData));
        account.id = (account.id || '').trim();
        account.name = (account.name || '').trim();
        account.email = (account.email || '').trim().toLowerCase();

        if (!/^[A-Za-z0-9_.-]{4,32}$/.test(account.id)) {
            await this.service.modal.error('아이디 형식을 확인해주세요.');
            return;
        }
        if (!account.name || !account.email) {
            await this.service.modal.error('이름과 이메일을 입력해주세요.');
            return;
        }
        if (!account.password || account.password.length < 8) {
            await this.service.modal.error('임시 비밀번호는 8자 이상 입력해주세요.');
            return;
        }

        const { code, data } = await wiz.call('invite', account);
        if (code !== 200) {
            await this.service.modal.error(data?.message || data || '계정 생성에 실패했습니다.');
            return;
        }

        this.showCreateModal = false;
        await this.service.modal.success('계정이 생성되었습니다.');
        await this.load();
    }

    public async toggleStatus(member: any) {
        const nextStatus = member.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
        const confirmed = await this.service.modal.show({
            title: nextStatus === 'ACTIVE' ? '계정 활성화' : '계정 비활성화',
            message: member.name + ' 계정을 ' + (nextStatus === 'ACTIVE' ? '활성화' : '비활성화') + '하시겠습니까?',
            action: '확인',
            actionBtn: nextStatus === 'ACTIVE' ? 'success' : 'error',
            status: nextStatus === 'ACTIVE' ? 'success' : 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('set_status', {
            id: member.id,
            status: nextStatus
        });
        if (code !== 200) {
            await this.service.modal.error(data?.message || data || '상태 변경에 실패했습니다.');
            return;
        }
        await this.load();
    }

    public roleClass(role: string) {
        return role === 'ADMIN'
            ? 'bg-purple-100 text-purple-700'
            : 'bg-blue-100 text-blue-700';
    }

    public statusClass(status: string) {
        return status === 'ACTIVE'
            ? 'bg-emerald-100 text-emerald-700'
            : 'bg-gray-100 text-gray-600';
    }
}

export default PageMembersComponent;